export default class Header {
    constructor() {
        this.header = document.querySelector('header');
        this.btMenuMobile = this.header.querySelector('.menuMobile');
        this.menu = this.header.querySelector('.menu');
        this.submenus = this.menu.querySelectorAll('.submenu');

        this.searchBtns = this.header.querySelectorAll('.btnBusca');
        this.modalBusca = document.querySelector('.modalBusca');

        this.ready();
    }

    ready() {
        if (this.btMenuMobile) {
            this.btMenuMobile.addEventListener(
                'click',
                () => {
                    this.btMenuMobile.classList.toggle('active');
                    this.menu.classList.toggle('active');
                    this.submenus.forEach((submenu) => {
                        submenu.classList.remove('active');
                    });
                },
                false
            );
        }

        if (document.body.clientWidth > 1000) {
            this.header.addEventListener('mouseover', () => {
                const allMenu = this.header.querySelectorAll('ul li.hasSubMenu');
                setTimeout(() => {
                    allMenu.forEach((item) => {
                        item.classList.add('activeHover');
                    });
                }, 500);
            });

            this.header.addEventListener('mouseout', () => {
                setTimeout(() => {
                    const allMenu = this.header.querySelectorAll('ul li.hasSubMenu');
                    allMenu.forEach((item) => {
                        item.classList.remove('activeHover');
                    });
                }, 500);
            });
        }

        if (document.body.clientWidth < 1000) {
            const itemsLink = this.menu.querySelectorAll('.multilevel');
            const voltarLinks = this.menu.querySelectorAll('.submenu .voltarLink');
            itemsLink.forEach((link) => {
                link.addEventListener('click', (event) => {
                    event.preventDefault();
                    link.parentElement.querySelector('.submenu').classList.add('active');
                });
            });
            voltarLinks.forEach((backlink) => {
                backlink.addEventListener('click', () => {
                    backlink.parentElement.classList.remove('active');
                });
            });
        }

        this.searchBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                this.modalBusca.classList.add('active');
                this.modalBusca.addEventListener('mouseleave', () => {
                    this.modalBusca.classList.remove('active');
                });
                this.modalBusca.querySelector('.closeModal').addEventListener('click', () => {
                    this.modalBusca.classList.remove('active');
                });
            });
        });
    }
}
new Header();
